import Vue from "vue";

import "./components";
import "./plugins";

new Vue({
  el: "#app"
});
